import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltRecordingPreviewStepsDialogSettingsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-settings-wireframe", __assign({}, transformedProps), children));
};
export default VeltRecordingPreviewStepsDialogSettingsWireframe;
